import { TTabName } from "../../../../utils/types";

export type TDeployWidgetOnboardingStepId =
  | "profile-essentials"
  | "profile-preview"
  | "appearance-live-preview"
  | "appearance-device-settings"
  | "deploy-guides-and-help";

export type TDeployWidgetOnboardingTab = Extract<
  TTabName,
  "Profile" | "Appearance" | "Deploy"
>;

export type TDeployWidgetOnboardingStep = {
  id: TDeployWidgetOnboardingStepId;
  tab: TDeployWidgetOnboardingTab;
  title: string;
  description: string;
  primaryActionLabel: string;
};

export const DEPLOY_WIDGET_ONBOARDING_STEPS: TDeployWidgetOnboardingStep[] = [
  {
    id: "profile-essentials",
    tab: "Profile",
    title: "Set the notification email",
    description:
      "Add the inbox that should receive new lead notifications so every widget submission reaches the right team right away.",
    primaryActionLabel: "Next: Preview",
  },
  {
    id: "profile-preview",
    tab: "Profile",
    title: "Use the profile preview",
    description:
      "This preview helps you confirm that the logo and default language look right before you move into appearance changes.",
    primaryActionLabel: "Next: Appearance",
  },
  {
    id: "appearance-live-preview",
    tab: "Appearance",
    title: "Customize with the live preview",
    description:
      "Use the live preview while you update the widget. These settings stay editable after launch, so there is no redeploy step later.",
    primaryActionLabel: "Next: Device Settings",
  },
  {
    id: "appearance-device-settings",
    tab: "Appearance",
    title: "Set mobile and desktop separately",
    description:
      "Desktop and mobile behavior can be configured independently and saved independently, so the widget can behave differently on each device.",
    primaryActionLabel: "Next: Deploy",
  },
  {
    id: "deploy-guides-and-help",
    tab: "Deploy",
    title: "Choose the right guide",
    description:
      "Pick the setup guide that matches your site or CMS, or use the Generic HTML guide as a fallback. Check deploy status to confirm the widget is live, and use the support contact options on this tab if you get stuck.",
    primaryActionLabel: "Finish",
  },
];

export const FIRST_DEPLOY_WIDGET_ONBOARDING_STEP_BY_TAB: Record<
  TDeployWidgetOnboardingTab,
  number
> = {
  Profile: 0,
  Appearance: 2,
  Deploy: 4,
};
